import { useTranslation } from "react-i18next";
import { NAMESPACES } from "@/i18n/constants";
import { cn } from "@/utils/class-name";
import { formatTimeAsHoursMinutesAndSeconds } from "@/utils/time";

interface ResponseTimeHintProps {
    responseTimeMs?: number;
    className?: string;
}

export function ResponseTimeHint({ responseTimeMs, className }: ResponseTimeHintProps) {
    const { t } = useTranslation(NAMESPACES.FEATURES.CARDS, {
        keyPrefix: "zone.on-demand-irrigation",
    });

    if (responseTimeMs === undefined) {
        return null;
    }

    const formattedResponseTime = formatTimeAsHoursMinutesAndSeconds(responseTimeMs, {
        includeSecondsWithMinutes: Math.floor(responseTimeMs / 1000) % 60 !== 0,
    });

    return (
        <p className={cn("text-xs text-muted-foreground mt-1", className)}>
            {t("response-time-hint", { duration: formattedResponseTime })}
        </p>
    );
}
